@if (isVisible()) {
  <div class="pagination-banner">
    <div class="pagination-info">
      <span class="showing-text">{{ paginationText() }}</span>
    </div>

    <div class="pagination-controls">
      <div class="rows-per-page">
        <span class="rows-label">Items per page</span>
        <app-popover-dropdown
          [options]="itemsPerPageOptions"
          [selectedValue]="selectedItemsPerPage()"
          [tight]="true"
          (selectionChange)="onItemsPerPageChange($event)"
        />
      </div>

      <div class="page-navigation">
        <!-- First page -->
        <ion-button
          fill="outline"
          color="medium"
          class="nav-btn"
          [disabled]="isFirstPage()"
          (click)="onFirstPage()"
          aria-label="First page"
        >
          <ion-icon name="chevron-back-outline" slot="icon-only"></ion-icon>
          <ion-icon name="chevron-back-outline" slot="icon-only"></ion-icon>
        </ion-button>

        <!-- Previous page -->
        <ion-button
          fill="outline"
          color="medium"
          class="nav-btn"
          [disabled]="isFirstPage()"
          (click)="onPreviousPage()"
          aria-label="Previous page"
        >
          <ion-icon name="chevron-back-outline" slot="icon-only"></ion-icon>
        </ion-button>

        <!-- Page numbers -->
        <div class="page-numbers">
          @for (page of pageNumbers(); track $index) {
            @if (isNumber(page)) {
              <ion-button
                fill="outline"
                [color]="
                  currentPage() === asNumber(page) ? 'primary' : 'medium'
                "
                class="page-btn"
                [class.active]="currentPage() === asNumber(page)"
                (click)="onGoToPage(asNumber(page))"
                [attr.aria-label]="'Go to page ' + page"
                [attr.aria-current]="
                  currentPage() === asNumber(page) ? 'page' : null
                "
              >
                {{ page }}
              </ion-button>
            } @else {
              <span class="ellipsis">{{ page }}</span>
            }
          }
        </div>

        <!-- Next page -->
        <ion-button
          fill="outline"
          color="medium"
          class="nav-btn"
          [disabled]="isLastPage()"
          (click)="onNextPage()"
          aria-label="Next page"
        >
          <ion-icon name="chevron-forward-outline" slot="icon-only"></ion-icon>
        </ion-button>

        <!-- Last page -->
        <ion-button
          fill="outline"
          color="medium"
          class="nav-btn"
          [disabled]="isLastPage()"
          (click)="onLastPage()"
          aria-label="Last page"
        >
          <ion-icon name="chevron-forward-outline" slot="icon-only"></ion-icon>
          <ion-icon name="chevron-forward-outline" slot="icon-only"></ion-icon>
        </ion-button>
      </div>
    </div>
  </div>
}
